<div class="files-list">
  <!-- TODO: Review tracking - files are mutable but only file.name available. May cause issues with duplicate file names -->
  @for (file of files; track file.file.name; let i = $index) {
    <div class="single-file">
      <img src="assets/images/dnd/ic-file.svg" width="45px" alt="file">
      <div class="info">
        <h4 class="name">
          {{ file?.file.name }}
        </h4>
        <p class="size">
          {{ formatBytes(file?.file.size) }}
        </p>
        <app-progress [progress]="file?.progress"></app-progress>
      </div>
      <img src="assets/images/dnd/ic-delete-file.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i)">
    </div>
  }
</div>
